import { createContext, useContext } from 'react';
import type { UsuarioSesion } from '@/lib/sesion';

/**
 * Quién ha entrado, para las pantallas que lo necesiten (el saludo del
 * Dashboard). `useAuth` vive solo en `Layout`, que ya ha consultado la sesión:
 * volver a pedir `/api/auth/me` desde cada pantalla sería repetir esa consulta.
 */
export const UsuarioContext = createContext<UsuarioSesion | null>(null);

export function useUsuario(): UsuarioSesion | null {
  return useContext(UsuarioContext);
}
